<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      class="form-input">
      <el-form-item
        :label="$attrs.name"
        :rules="$attrs.props.rules"
        :class="{isRequired: !isRequired}"
        prop="newValue"
        class="item"
      >
        <div class="img-container">
          <AppQiniu
            :is-has="!!form.newValue"
            :type="$attrs.props.fileType || 'pdf'"
            class="app-qiniu-box"
            width="160px"
            height="160px"
            token-url="/resource/upload_token"
            token-mode="name"
            @success="handleAvatarSuccess"
          />
          <iframe
            v-if="form.newValue"
            :src="form.newValue"
            class="img-box"
            alt="file" />
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import AppQiniu from '../../../../components/AppQiniu/index.vue';

export default {
  name: 'ImUploadFile',
  components: {
    AppQiniu,
  },
  props: {
    value: String,
  },
  data() {
    return {
      form: {
        newValue: this.$attrs.value,
      },
    };
  },
  computed: {
    isRequired() {
      return this.$attrs.props.rules && this.$attrs.props.rules.required;
    },
  },
  watch: {
    value: {
      handler(vl) {
        this.form.newValue = vl;
      },
      deep: true,
      immediate: true,
    },
    'form.newValue': {
      handler(vl) {
        this.$emit('onInput', vl);
      },
      deep: true,
    },
  },
  methods: {
    validate() {
      let state = false;
      this.$refs.form.validate((res) => {
        state = res;
      });
      return state;
    },
    handleAvatarSuccess(res) {
      this.form.newValue = res.url;
    },
  },
};
</script>

<style scoped>
.form-input{
  display: flex;
  flex-direction: row;
}
.item{
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 20px;
}
.isRequired{
  padding-left: 10px;
}
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.img-container{
  position: relative;
}
.app-qiniu-box{
  z-index: 1;
}
.img-box{
  position: absolute;
  top: -2px;
  left: -2px;
  width: 162px;
  height: 162px;
  object-fit: cover;
  display: inline-block;
  border: 1px solid #eee;
  border-radius: 4px;
  z-index: 0;
}
</style>
